import APIError from "../Error/error";
import { errorCode } from "../Error/errocode";
/**
 *
 * @param {any}data
 * @param {number}statusCode
 * @returns {object}
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleResponseFailure = (data: any, statusCode: number) => {
  if (statusCode >= 400 && statusCode < 500) {
    return new APIError({
      statusCode,
      apiErrorMessage: data.code
        ? errorCode[data.code]
        : "Something went wrong please click on reload icon to refresh again if the issue still persists please reach out to VARAHA admin;",
      errorCode: data.code,
    });
  } else {
    return new APIError({
      statusCode,
      apiErrorMessage: "Something went wrong",
      errorCode: undefined,
    });
  }
};

export default handleResponseFailure;
